<template>
  <div>
    <!-- 标题 -->
    <mtd-row>
      <mtd-col :span="12" class="height-full">
        <span class="page-title-32">日志查询</span>
      </mtd-col>
    </mtd-row>
    <!-- 权限申请配置页面 -->
    <mtd-row v-if="user_have_permission">
      <QueryMobileLog/>
    </mtd-row>
    <mtd-row v-if="!user_have_permission">
      <PermissionApply/>
    </mtd-row>
  </div>
</template>

<script>
  import {mapActions} from "vuex";
  import moment from "moment";
  import QueryMobileLog from "./query_mobile_log.vue"
  import PermissionApply from "./permission_apply"

  export default {
    name: "mobile_app_log_query",
    components: {
      QueryMobileLog,
      PermissionApply
    },
    filters: {
      dateTimeFormat(dateTime) {
        return moment(dateTime)
          .utcOffset(480)
          .format('YYYY-MM-DD HH:mm:ss');
      },
    },
    data() {
      return {
        user_have_permission: false,
        apply_list: [],
      }
    },
    computed: {
      login_user() {
        return this.$store.getters.get_login_user;
      },
    },
    mounted() {
      this.query_user_permissions();
    },
    methods: {
      ...mapActions({
        'api_judge_user_permissions': 'api_mobile_protect_common_query_judge_user_permissions',
      }),
      query_user_permissions() {
        this.api_judge_user_permissions().then((res) => {
          const {data} = res;
          if (!data || !('hasPermissions' in data)) {
            return;
          }
          const {hasPermissions} = data;
          this.user_have_permission = hasPermissions;
        });
      },
    }
  }
</script>

<style scoped>
  .test-clear {
    clear: both;
  }
</style>
